import { render, staticRenderFns } from "./FiscalConfig.vue?vue&type=template&id=f13dba64&scoped=true"
import script from "./FiscalConfig.vue?vue&type=script&lang=js"
export * from "./FiscalConfig.vue?vue&type=script&lang=js"
import style0 from "./FiscalConfig.vue?vue&type=style&index=0&id=f13dba64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13dba64",
  null
  
)

export default component.exports